import {Button} from '@/components/ui/button/Button'
import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {ChevronLeftIcon, ChevronRightIcon} from '@/components/ui/icon/Icon'
import {MonthCaptionProps, useDayPicker} from 'react-day-picker'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {RangeDatePickerCaptionContainer} from './style'
import {RangeCalendarMonthSelect} from './RangeCalendarMonthSelect'
import {RangeCalendarYearSelect} from './RangeCalendarYearSelect'

export const RangeCalendarMonthCaption = (props: MonthCaptionProps) => {
    const {months, goToMonth, nextMonth, previousMonth} = useDayPicker()
    const isFirstMonth = props.displayIndex === 0
    const isLastMonth = props.displayIndex === months.length - 1

    const handleDateChange = (newDate: Date) => {
        goToMonth(newDate)
    }

    return (
        <RangeDatePickerCaptionContainer>
            {isFirstMonth ? (
                <Button variant="ghost" shape="square" onClick={() => previousMonth && goToMonth(previousMonth)}>
                    <ChevronLeftIcon />
                </Button>
            ) : (
                <div />
            )}
            <GridItem justify="center" align="center">
                <Flexbox gap={2} align="center">
                    <RangeCalendarMonthSelect currentDate={props.calendarMonth.date} onMonthChange={handleDateChange} />
                    <RangeCalendarYearSelect currentDate={props.calendarMonth.date} onYearChange={handleDateChange} />
                </Flexbox>
            </GridItem>
            {isLastMonth && (
                <GridItem justify="end">
                    <Button variant="ghost" shape="square" onClick={() => nextMonth && goToMonth(nextMonth)}>
                        <ChevronRightIcon />
                    </Button>
                </GridItem>
            )}
        </RangeDatePickerCaptionContainer>
    )
}
